// Purpose: Stock Opname Redux actions — fetch product options and stock opname check data
// Caller: StockOpnameCheckPage (view)
// Dependencies: services/stockOpnameService, store/actionTypes/stockOpname
// Main Functions: getProductOptions, getStockOpnameCheck, resetStockOpname
// Side Effects: HTTP GET calls, dispatches Redux actions

import Swal from "sweetalert2";
import * as Type from "store/actionTypes/stockOpname";
import {
  getProductOptions as getProductOptionsService,
  getStockOpnameCheck as getStockOpnameCheckService,
} from "services";

export const getProductOptions = () => async (dispatch) => {
  try {
    dispatch({ type: Type.STOCK_OPNAME_REQUEST });
    const res = await getProductOptionsService();
    dispatch({
      type: Type.GET_PRODUCT_OPTIONS_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    dispatch({
      type: Type.GET_PRODUCT_OPTIONS_ERROR,
      payload: err.message,
    });
  }
};

export const getStockOpnameCheck = (params) => async (dispatch) => {
  try {
    dispatch({ type: Type.STOCK_OPNAME_REQUEST });
    const res = await getStockOpnameCheckService(params);
    dispatch({
      type: Type.GET_STOCK_OPNAME_CHECK_SUCCESS,
      payload: res.data,
    });
  } catch (err) {
    Swal.fire("error", err.message, "error");
    dispatch({
      type: Type.GET_STOCK_OPNAME_CHECK_ERROR,
      payload: err.message,
    });
  }
};

export const resetStockOpname = () => (dispatch) => {
  dispatch({ type: Type.STOCK_OPNAME_RESET });
};
